module.exports = __webpack_public_path__ + "static/media/SJE091_01.b36b7345.jpg";